import ActionContainer from 'components/ActionContainer/ActionContainer';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FirestopDetailsSection } from './FirestopDetailsSection';
import { FirestopProductsSection } from './FirestopProductsSection';

export const FirestopCatalogsSection = ({
  loading,
  isLoadingFirestopDetails,
  firestopDetails,
  onAddFirestopDetail,
  onChangeFirestopDetail,
  onDeleteFirestopDetail,
  isLoadingFirestopProducts,
  firestopProducts,
  onAddFirestopProduct,
  onChangeFirestopProduct,
  onDeleteFirestopProduct,
}) => {
  const { t } = useTranslation('common');

  const [open, setOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);

  return (
    <ActionContainer
      title={t('project_dialog.section_firestop_documentation')}
      closable
      open={open}
      setOpen={setOpen}
    >
      <FirestopDetailsSection
        loading={loading}
        isLoadingFirestopDetails={isLoadingFirestopDetails}
        open={openDetails}
        setOpen={setOpenDetails}
        firestopDetails={firestopDetails}
        onAddFirestopDetail={onAddFirestopDetail}
        onChangeFirestopDetail={onChangeFirestopDetail}
        onDeleteFirestopDetail={onDeleteFirestopDetail}
      />
      <FirestopProductsSection
        loading={loading}
        isLoadingFirestopProducts={isLoadingFirestopProducts}
        open={openProducts}
        setOpen={setOpenProducts}
        firestopProducts={firestopProducts}
        onAddFirestopProduct={onAddFirestopProduct}
        onChangeFirestopProduct={onChangeFirestopProduct}
        onDeleteFirestopProduct={onDeleteFirestopProduct}
      />
    </ActionContainer>
  );
};

FirestopCatalogsSection.propTypes = {
  loading: PropTypes.bool,
  isLoadingFirestopDetails: PropTypes.bool,
  firestopDetails: PropTypes.array,
  onAddFirestopDetail: PropTypes.func,
  onChangeFirestopDetail: PropTypes.func,
  onDeleteFirestopDetail: PropTypes.func,
  isLoadingFirestopProducts: PropTypes.bool,
  firestopProducts: PropTypes.array,
  onAddFirestopProduct: PropTypes.func,
  onChangeFirestopProduct: PropTypes.func,
  onDeleteFirestopProduct: PropTypes.func,
};

FirestopCatalogsSection.defaultProps = {
  loading: false,
  isLoadingFirestopDetails: false,
  firestopDetails: [],
  onAddFirestopDetail: () => {},
  onChangeFirestopDetail: () => {},
  onDeleteFirestopDetail: () => {},
  isLoadingFirestopProducts: false,
  firestopProducts: [],
  onAddFirestopProduct: () => {},
  onChangeFirestopProduct: () => {},
  onDeleteFirestopProduct: () => {},
};
